import { useRef, useEffect } from 'react';

export const usePreviousPropValue = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};


